import axios from 'axios'
import crypto from 'crypto-js'

export const getWeatherData = (city, cityid, callback) => {
  let urlStr = 'https://www.tianqiapi.com/api/'
  if (city) {
    urlStr += '?city=' + city
  } else if (cityid) {
    urlStr += '?cityid=' + cityid
  }
  if (callback) {
    let script = document.createElement('script')
    script.src = urlStr
    script.async = true
    script.type = 'text/javascript'
    window['jsonpCallback'] = data => {
      callback && callback(data.results[0])
    }
    document.body.appendChild(script)
  } else {
    return axios({
      url: urlStr,
      method: 'get',
      timeout: 30000
    })
  }
}

export const getHFeatherData = city => {
  const appKey = '37bc0def43ef45109f6f88d3be432794'
  // const urlStr = encodeURI(`https://free-api.heweather.net/s6/weather/now?key=${appKey}&location=${city}`)
  const urlStr = encodeURI(`https://devapi.qweather.com/v7/weather/now?key=${appKey}&location=${city}`)
  return axios({
    url: urlStr,
    method: 'get',
    timeout: 30000
  })
}
export const getLocationId = city => {
  const appKey = '37bc0def43ef45109f6f88d3be432794'
  const urlStr = encodeURI(`https://geoapi.qweather.com/v2/city/lookup?key=${appKey}&location=${city}`)
  return axios({
    url: urlStr,
    method: 'get',
    timeout: 30000
  })
}

export const getXZWeatherData = (city, callback) => {
  const uid = 'UC52A309E8'
  const key = 'gdblfhycr1wqsy3c'
  // 获取当前时间戳
  const ts = Math.floor(new Date().getTime() / 1000)
  let str = 'ts=' + ts + '&uid=' + uid
  // 通过HMAC-SHA1加密并作base64编码获得签名
  let sig = crypto.HmacSHA1(str, key).toString(crypto.enc.Base64)
  sig = window.encodeURIComponent(sig)
  // 拼接得到最终签名
  str = str + '&sig=' + sig
  // 拼接得到最终的请求URL
  const url = 'https://api.seniverse.com/v3/weather/now.json?location=' + city + '&' + str + '&callback=jsonpCallback'

  let script = document.createElement('script')
  script.src = url
  script.async = true
  script.type = 'text/javascript'
  window['jsonpCallback'] = data => {
    callback && callback(data)
  }
  document.body.appendChild(script)
}
